import script from "./LcabMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./LcabMenu.vue?vue&type=script&lang=ts&setup=true"

import "./LcabMenu.vue?vue&type=style&index=0&id=556d2b64&lang=scss"

const __exports__ = script;

export default __exports__